import { render, staticRenderFns } from "./TradeEdit.vue?vue&type=template&id=30507e80&scoped=true&"
import script from "./TradeEdit.vue?vue&type=script&lang=js&"
export * from "./TradeEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30507e80",
  null
  
)

export default component.exports